import { Component, computed, inject } from '@angular/core';
import {
  ACTION_DATA_TEMPLATE,
  ActionComponent,
} from '@kinet-open-network/client/automations/feature/builder';
import {
  datepicker,
  DynamicFormField,
  formBuilder,
} from '@kinet-open-network/client/core/forms/ui';
import { CustomersService } from '@kinet-open-network/client/customers/data-access';
import { IAutomationActionGenerateCustomerRentalInvoiceData } from '@kinet-open-network/shared/data-access/model-pbgas';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'kon-generate-customer-rental-invoice-action',
  imports: [FormlyModule],
  template: ACTION_DATA_TEMPLATE,
})
export class GenerateCustomerRentalInvoiceActionComponent extends ActionComponent<'generate-customer-rental-invoice'> {
  readonly customersService = inject(CustomersService);

  override fields = computed<DynamicFormField[]>(() =>
    formBuilder([
      datepicker('date', 'Obdobie')
        .view('month')
        .description(
          'Ak nie je zadané - vygeneruje sa faktúra za predchádzajúci mesiac',
        ),
    ]),
  );

  override dataToModel(
    data: Partial<IAutomationActionGenerateCustomerRentalInvoiceData>,
  ) {
    return {
      date: data.date ? new Date(data.date) : undefined,
    };
  }
}
